"use client";

import { Chip, Icon } from "daskapital-ds";

import getBlockStyles from "@/lib/wordpress/blocks/getBlockStyles";
import { useMemo } from "react";

export type IBlockChip = {
  attrs: {
    anchor?: string;
    text?: string;
    icon?: string;
    variant?: string;
    iconBackground?: string;
    className?: string;
    style?: Record<string, unknown>;
  };
};

export default function BlockChip({ attrs }: IBlockChip) {
  const { text, icon, variant, iconBackground, className, style } = attrs || {};

  // The block's registered default for `icon` is "icon-check". Gutenberg omits
  // an attribute from the saved markup when it equals its default, so `icon`
  // is `undefined` here for any chip left at the default (not `"icon-check"`).
  // An explicit empty string ("no icon", e.g. the plain eyebrow chip) must be
  // kept as-is, so this only backfills the true "attribute absent" case.
  const resolvedIcon = icon ?? "icon-check";

  const elStyle = useMemo(() => ({
    ...getBlockStyles({
      style,
    })
  }), [style]);

  return (
    <Chip
      variant={variant}
      icon={resolvedIcon ? <Icon icon={resolvedIcon} style={{ fontSize: 11, color: "#fff" }} /> : undefined}
      iconBackground={iconBackground || undefined}
      className={className}
      style={elStyle}
    >
      {text}
    </Chip>
  );
}
